// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__3EXXY","cellSelected":"Cell_cellSelected__3p24-"};